import { MessageSquare, Sun, Tag, Handshake, Megaphone } from "lucide-react";
import api from "@/lib/api";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const mediaSrc = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);
export const B = "/vesta/bacheca";

export const C = { page: "#0D0F12", card: "#16191E", elev: "#1F242D", input: "#121418", border: "#2A303C", text2: "#9CA3AF", muted: "#6B7280" };

export const TIPI = {
  discussione: { label: "Discussione", short: "Discussione", icon: MessageSquare, color: "#9CA3AF" },
  impianto: { label: "Impianto realizzato", short: "Impianto", icon: Sun, color: "#34D399" },
  mercatino: { label: "Mercatino", short: "Mercatino", icon: Tag, color: "#38BDF8" },
  collaborazione: { label: "Collaborazioni", short: "Collaborazione", icon: Handshake, color: "#C084FC" },
  comunicazione: { label: "Comunicazioni Torri", short: "Comunicazione Torri", icon: Megaphone, color: "#E59B6E" },
};

export const EXTRA = {
  impianto: [["kwp", "Potenza (kWp)"], ["tetto", "Tipo di tetto"], ["prodotti", "Prodotti Torri usati"], ["localita", "Località"]],
  mercatino: [["prezzo", "Prezzo (€)"], ["condizioni", "Condizioni"], ["zona", "Zona di ritiro"]],
  collaborazione: [["ruolo", "Cerco / Offro"], ["zona", "Zona"]],
};

export const ago = (iso) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "ora";
  if (s < 3600) return `${Math.floor(s / 60)} min`;
  if (s < 86400) return `${Math.floor(s / 3600)} h`;
  if (s < 604800) return `${Math.floor(s / 86400)} g`;
  return new Date(iso).toLocaleDateString("it-IT");
};

export const price = (v) => (!v ? "" : /€/.test(v) ? v : `${v} €`);

export async function uploadMedia(file, onProgress) {
  const { data: init } = await api.post(`${B}/upload/init`, { filename: file.name, size: file.size, content_type: file.type });
  const cs = init.chunk_size;
  const n = Math.max(1, Math.ceil(file.size / cs));
  for (let i = 0; i < n; i++) {
    const fd = new FormData();
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * cs, (i + 1) * cs), "chunk");
    await api.post(`${B}/upload/${init.upload_id}/chunk`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 180000 });
    onProgress?.(Math.round(((i + 1) / n) * 95));
  }
  const { data } = await api.post(`${B}/upload/${init.upload_id}/complete`, {}, { timeout: 300000 });
  onProgress?.(100);
  return data;
}
